// ❌ PROBLEMA ATUAL - Lines 50-65
// Esta função é chamada a cada render e faz múltiplas chamadas watch()
/*
const getCurrentStepLabel = () => {
  if (flowIndex !== null) {
    const currentFlows = watch("specialFlows") || [];
    if (currentFlows[flowIndex] && currentFlows[flowIndex].steps) {
      const currentStep = currentFlows[flowIndex].steps.find(
        (s) => s.id === step.id
      );
      return currentStep?.label || step.label;
    }
  } else {
    const currentSteps = watch("defaultFlowSteps") || [];
    if (currentSteps[index]) {
      return currentSteps[index].label || step.label;
    }
  }
  return step.label;
};

const stepLabel = getCurrentStepLabel();
*/

// ✅ SOLUÇÃO OTIMIZADA - SUBSTITUIR POR ISSO:
import { IconGripVertical, IconTrash, IconWand, IconMoodSmile } from "@tabler/icons-react";
import { memo, useEffect, useRef, useMemo, useState, useCallback } from "react";
import { Accordion, Button, Form } from "react-bootstrap";
import Select from "react-select";
import EmojiPickerWrapper from "../../EmojiPIcker";

const DynamicFlowStepComponent = memo(
  ({
    step,
    index,
    flowType,
    flowIndex = null,
    register,
    watch,
    setValue,
    handleAIFill,
    ImageSelect,
    NEXT_STEP_OPIONS,
    flowMode = "advanced",
    onRemove,
    canRemove = true,
    dragRef, // ✅ CORREÇÃO: Receber dragRef para aplicar apenas no ícone
  }) => {
    const [isExpanded, setIsExpanded] = useState(index === 0);
    const isInitializedRef = useRef(false);
    const userChangedRef = useRef(false);
    
    // ✅ CORREÇÃO: Ref para rastrear mudança de step.id
    const currentStepIdRef = useRef(step.id);

    // ✅ SOLUÇÃO: Estados locais para performance
    const [localTextareaValue, setLocalTextareaValue] = useState("");
    const [localLabelValue, setLocalLabelValue] = useState("");
    
    // Estados para o EmojiPicker
    const [showEmojiPicker, setShowEmojiPicker] = useState(false);
    const textareaRef = useRef(null);
    const emojiPickerRef = useRef(null);

    const stepKey =
      flowIndex !== null
        ? `specialFlows.${flowIndex}.${step.key}`
        : `defaultFlow.${step.key}`;

    const nextStepKey =
      flowIndex !== null
        ? `specialFlows.${flowIndex}.${step.key}NextStep`
        : `defaultFlow.${step.key}NextStep`;

    // ✅ SOLUÇÃO: Obter valores apenas quando necessário
    const stepValue = watch(stepKey);
    const nextStepValue = watch(nextStepKey);

    // ✅ SOLUÇÃO: useMemo sem watch() nas dependências
    const stepLabel = useMemo(() => {
      if (localLabelValue) return localLabelValue;

      if (flowIndex !== null) {
        const currentFlows = watch("specialFlows") || [];
        if (currentFlows[flowIndex]?.steps) {
          const currentStep = currentFlows[flowIndex].steps.find(
            (s) => s.id === step.id
          );
          return currentStep?.label || step.label;
        }
      } else {
        const currentSteps = watch("defaultFlowSteps") || [];
        if (currentSteps[index]) {
          return currentSteps[index].label || step.label;
        }
      }
      return step.label;
    }, [localLabelValue, flowIndex, step.id, step.label, index]);

    // ✅ CORREÇÃO: Reset quando step.id muda (componente reutilizado)
    useEffect(() => {
      if (currentStepIdRef.current !== step.id) {
        console.log('🔄 Step ID mudou, resetando estado:', {
          oldId: currentStepIdRef.current,
          newId: step.id
        });
        
        // Reset completo do estado
        isInitializedRef.current = false;
        setLocalTextareaValue("");
        setLocalLabelValue("");
        currentStepIdRef.current = step.id;
      }
    }, [step.id]);

    // ✅ SOLUÇÃO: Inicializar valores locais de forma mais robusta
    useEffect(() => {
      if (!isInitializedRef.current) {
        const currentValue = watch(stepKey);
        const currentNextStep = watch(nextStepKey);

        // ✅ CORREÇÃO: Inicializar sempre com string vazia para novos componentes
        const safeCurrentValue = currentValue || "";
        const safeCurrentNextStep = currentNextStep || "";
        
        setLocalTextareaValue(safeCurrentValue);
        setLocalLabelValue(stepLabel || "");

        // ✅ CORREÇÃO: Definir valores vazios explicitamente para novas etapas
        setValue(stepKey, safeCurrentValue, { shouldValidate: false, shouldDirty: false });
        setValue(nextStepKey, safeCurrentNextStep, { shouldValidate: false, shouldDirty: false });

      
        isInitializedRef.current = true;
      }
    }, [stepKey, nextStepKey, setValue, watch, stepLabel, step.id]);

    // ✅ NOVA FUNCIONALIDADE: Sincronizar valor local quando o formulário é atualizado externamente (ex: pela IA)
    const lastFormValueRef = useRef("");
    
    useEffect(() => {
      if (isInitializedRef.current && stepValue !== undefined) {
        // Verificar se o valor do formulário mudou externamente (não pelo usuário)
        if (stepValue !== lastFormValueRef.current && stepValue !== localTextareaValue) {
         
          setLocalTextareaValue(stepValue || "");
        }
        lastFormValueRef.current = stepValue || "";
      }
    }, [stepValue, stepKey]); // ✅ Removido localTextareaValue das dependências

    // ✅ SOLUÇÃO: Handler otimizado para textarea
    const handleTextareaChange = (e) => {
      setLocalTextareaValue(e.target.value);
    };

    // ✅ SOLUÇÃO: Sincronizar com formulário apenas no blur
    const handleTextareaBlur = (e) => {
      const newValue = e.target.value;
      setValue(stepKey, newValue, {
        shouldValidate: false,
        shouldDirty: true,
      });
      // ✅ CORREÇÃO: Atualizar ref para evitar loop no próximo useEffect
      lastFormValueRef.current = newValue;
    };

    // Função para inserir emoji
    const handleEmojiSelect = useCallback(
      (emoji) => {
        if (textareaRef.current) {
          const textarea = textareaRef.current;
          const start = textarea.selectionStart;
          const end = textarea.selectionEnd;

          const currentValue = textarea.value || "";

          // Inserir emoji na posição do cursor
          const newValue =
            currentValue.substring(0, start) +
            emoji +
            currentValue.substring(end);

          // Calcular nova posição do cursor
          const newCursorPosition = start + emoji.length;

          // Atualizar valor local e formulário
          setLocalTextareaValue(newValue);
          setValue(stepKey, newValue, {
            shouldValidate: true,
            shouldDirty: true,
            shouldTouch: true,
          });
          // ✅ CORREÇÃO: Atualizar ref para evitar loop
          lastFormValueRef.current = newValue;

          // Atualizar posição do cursor
          setTimeout(() => {
            if (textareaRef.current) {
              textareaRef.current.value = newValue;
              textareaRef.current.focus();
              textareaRef.current.setSelectionRange(
                newCursorPosition,
                newCursorPosition
              );
            }
          }, 0);
        }
      },
      [setValue, stepKey]
    );

    // Função para inserir imagem
    const handleImageInsert = useCallback(
      (imageUrl) => {
        const currentValue = localTextareaValue || "";
        // Inserir a URL da imagem no final do texto atual com uma nova linha se necessário
        const separator = currentValue && currentValue.trim() !== "" ? "\n\n" : "";
        const newValue = currentValue + separator + imageUrl;
        
        // Atualizar valor local e formulário
        setLocalTextareaValue(newValue);
        setValue(stepKey, newValue, {
          shouldValidate: true,
          shouldDirty: true,
          shouldTouch: true,
        });
        // ✅ CORREÇÃO: Atualizar ref para evitar loop
        lastFormValueRef.current = newValue;

        // Focar no textarea após inserir a imagem
        if (textareaRef.current) {
          setTimeout(() => {
            textareaRef.current.focus();
            textareaRef.current.setSelectionRange(newValue.length, newValue.length);
          }, 100);
        }
      },
      [localTextareaValue, setValue, stepKey]
    );

    // Função para alternar o emoji picker
    const toggleEmojiPicker = useCallback((e) => {
      e.preventDefault();
      e.stopPropagation();
      setShowEmojiPicker((prev) => !prev);
    }, []);

    // Fechar emoji picker quando clicar fora
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          showEmojiPicker &&
          emojiPickerRef.current &&
          !emojiPickerRef.current.contains(event.target) &&
          !event.target.closest(".emoji-picker-button")
        ) {
          setShowEmojiPicker(false);
        }
      };

      if (showEmojiPicker) {
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("touchstart", handleClickOutside);
      }

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
        document.removeEventListener("touchstart", handleClickOutside);
      };
    }, [showEmojiPicker]);

    // Fechar emoji picker quando o componente for desmontado
    useEffect(() => {
      return () => {
        setShowEmojiPicker(false);
      };
    }, []);

    // ✅ SOLUÇÃO: Handler otimizado para label
    const handleLabelChange = (e) => {
      const newLabel = e.target.value;
      setLocalLabelValue(newLabel);
    };

    // ✅ SOLUÇÃO: Sincronizar label apenas no blur
    const handleLabelBlur = (e) => {
      const newLabel = e.target.value;
      userChangedRef.current = true;

      if (flowIndex !== null) {
        const currentFlows = watch("specialFlows") || [];
        if (currentFlows[flowIndex]?.steps) {
          const updatedFlows = [...currentFlows];
          const stepIndex = updatedFlows[flowIndex].steps.findIndex(
            (s) => s.id === step.id
          );
          if (stepIndex !== -1) {
            updatedFlows[flowIndex].steps[stepIndex] = {
              ...updatedFlows[flowIndex].steps[stepIndex],
              label: newLabel,
            };
            setValue("specialFlows", updatedFlows, {
              shouldValidate: false,
              shouldDirty: true,
            });
          }
        }
      } else {
        const currentSteps = watch("defaultFlowSteps") || [];
        const updatedSteps = [...currentSteps];
        if (updatedSteps[index]) {
          updatedSteps[index] = { ...updatedSteps[index], label: newLabel };
          setValue("defaultFlowSteps", updatedSteps, {
            shouldValidate: false,
            shouldDirty: true,
          });
        }
      }

      setTimeout(() => {
        userChangedRef.current = false;
      }, 100);
    };

    const circleColor =
      flowType === "special"
        ? "bg-warning text-white"
        : "bg-primary text-white";

    return (
      <Accordion className="mb-3">
        <Accordion.Item eventKey={step.id}>
          <Accordion.Header onClick={() => setIsExpanded(!isExpanded)}>
            <div className="d-flex align-items-center justify-content-between w-100 me-3">
              <div className="d-flex align-items-center">
                {/* ✅ CORREÇÃO: Elemento drag handle dedicado envolvendo o ícone */}
                <div
                  ref={dragRef}
                  className="me-2 d-flex align-items-center"
                  style={{
                    cursor: "grab",
                    padding: "4px",
                    borderRadius: "4px",
                    transition: "background-color 0.2s",
                    userSelect: "none",
                  }}
                  onMouseEnter={(e) =>
                    (e.target.style.backgroundColor = "#f8f9fa")
                  }
                  onMouseLeave={(e) =>
                    (e.target.style.backgroundColor = "transparent")
                  }
                  onMouseDown={(e) => {
                    e.target.style.cursor = "grabbing";
                    e.stopPropagation(); // Evitar que o Accordion interfira
                  }}
                  onMouseUp={(e) => (e.target.style.cursor = "grab")}
                  onClick={(e) => e.stopPropagation()} // Evitar que o clique abra/feche o accordion
                  title="Arraste para reordenar"
                >
                  <IconGripVertical size={16} />
                </div>
                <div
                  className={`rounded-circle ${circleColor} d-flex align-items-center justify-content-center me-3`}
                  style={{ width: "32px", height: "32px", fontSize: "14px" }}
                >
                  {index + 1}
                </div>
                <div className="d-flex align-items-center">
                  <span className="me-2" style={{ fontSize: "18px" }}>
                    {step.icon !== "?" ? step.icon : "📝"}
                  </span>
                  <strong>{stepLabel}</strong>
                </div>
              </div>
              {canRemove && (
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    onRemove();
                  }}
                >
                  <IconTrash size={14} />
                </Button>
              )}
            </div>
          </Accordion.Header>
          <Accordion.Body>
            <div className="mb-4 pb-4">
              <div className="d-flex align-items-center justify-content-between mb-3">
                <div className="d-flex align-items-center">
                  <div>
                    <h6 className="mb-1 d-flex align-items-center">
                      <span className="me-2">{step.icon}</span>
                      {/* ✅ CORREÇÃO: Usar apenas localLabelValue para evitar reset */}
                      <Form.Control
                        type="text"
                        size="sm"
                        style={{ width: "200px" }}
                        placeholder={step.label}
                        value={localLabelValue}
                        onChange={handleLabelChange}
                        onBlur={handleLabelBlur}
                      />
                    </h6>
                    <small className="text-muted">{step.description}</small>
                  </div>
                </div>
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() => handleAIFill(stepKey, step)}
                >
                  <IconWand className="me-1" size={14} />
                  {flowMode === "basic" ? "Preencher com IA" : "IA"}
                </Button>
              </div>

              <Form.Group className="mb-3">
                <div className="d-flex justify-content-between mb-1">
                  <Form.Label className="visually-hidden">
                    Conteúdo da etapa
                  </Form.Label>
                  {/* Botão do emoji picker */}
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    className="emoji-picker-button p-1 ms-auto"
                    onClick={toggleEmojiPicker}
                    type="button"
                  >
                    <IconMoodSmile size={16} />
                  </Button>
                </div>

                <div style={{ position: "relative" }}>
                  {/* ✅ SOLUÇÃO: Controlled component com onChange/onBlur */}
                  <Form.Control
                    as="textarea"
                    rows={4}
                    value={localTextareaValue}
                    onChange={handleTextareaChange}
                    onBlur={handleTextareaBlur}
                    placeholder={
                      flowMode === "basic"
                        ? step.placeholder ||
                          `O que o agente deve falar na etapa "${stepLabel.toLowerCase()}"?`
                        : `Digite o texto para ${stepLabel.toLowerCase()}...`
                    }
                    style={{ fontSize: "14px" }}
                    ref={textareaRef}
                  />

                  {/* Emoji Picker */}
                  {showEmojiPicker && (
                    <div
                      ref={emojiPickerRef}
                      style={{
                        position: "absolute",
                        top: "100%",
                        right: 0,
                        zIndex: 1050,
                        marginTop: "5px",
                      }}
                    >
                      <EmojiPickerWrapper
                        onEmojiSelect={handleEmojiSelect}
                        onClose={() => setShowEmojiPicker(false)}
                      />
                    </div>
                  )}
                </div>

                {flowMode === "basic" && step.placeholder && (
                  <Form.Text className="text-muted">
                    💡 Exemplo: {step.placeholder}
                  </Form.Text>
                )}
              </Form.Group>

              <ImageSelect
                value={stepValue}
                onChange={(value) => setValue(stepKey, value)}
                onImageInsert={handleImageInsert}
                placeholder="Adicionar uma imagem (opcional)"
                fieldName={stepKey}
              />

              {flowMode === "advanced" && (
                <Form.Group>
                  <Form.Label>Chamar função</Form.Label>
                  <Select
                    options={NEXT_STEP_OPIONS}
                    placeholder="Selecione a função..."
                    value={NEXT_STEP_OPIONS.find(
                      (opt) => opt.value === nextStepValue
                    )}
                    onChange={(selected) =>
                      setValue(nextStepKey, selected?.value || "")
                    }
                    styles={{
                      menuPortal: (provided) => ({
                        ...provided,
                        zIndex: 999999999,
                      }),
                      control: (provided, state) => ({
                        ...provided,
                        minHeight: "38px",
                        borderColor: state.isFocused ? "#86b7fe" : "#dee2e6",
                        boxShadow: state.isFocused
                          ? "0 0 0 0.25rem rgba(13, 110, 253, 0.25)"
                          : "none",
                        "&:hover": { borderColor: "#b0b8c1" },
                      }),
                      placeholder: (provided) => ({
                        ...provided,
                        color: "#6c757d",
                      }),
                    }}
                    menuPortalTarget={
                      typeof window !== "undefined" ? document.body : ""
                    }
                  />
                </Form.Group>
              )}
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    );
  }
);

DynamicFlowStepComponent.displayName = "DynamicFlowStepComponent";
export default DynamicFlowStepComponent;
